"use strict";
exports.__esModule = true;
exports.global_primary_color_100 = {
  "name": "--pf-v5-global--primary-color--100",
  "value": "#06c",
  "var": "var(--pf-v5-global--primary-color--100)"
};
exports["default"] = exports.global_primary_color_100;